var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "#EDEFF1",
    stroke: "#D1D8DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 14C17 12.3431 18.3432 11 20 11C21.6569 11 23 12.3431 23 14C23 15.6569 21.6569 17 20 17C18.3432 17 17 15.6569 17 14ZM20 9C17.2386 9 15 11.2386 15 14C15 16.7614 17.2386 19 20 19C22.7615 19 25 16.7614 25 14C25 11.2386 22.7615 9 20 9ZM16 21C14.6739 21 13.4022 21.5268 12.4645 22.4645C11.5268 23.4021 11 24.6739 11 26V28C11 28.5523 11.4477 29 12 29C12.5523 29 13 28.5523 13 28V26C13 25.2043 13.3161 24.4413 13.8787 23.8787C14.4413 23.3161 15.2044 23 16 23H24C24.7957 23 25.5587 23.3161 26.1213 23.8787C26.6839 24.4413 27 25.2044 27 26V28C27 28.5523 27.4477 29 28 29C28.5523 29 29 28.5523 29 28V26C29 24.6739 28.4732 23.4021 27.5355 22.4645C26.5979 21.5268 25.3261 21 24 21H16Z",
    fill: "#94A2AD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.70f5051e793547af1619867188500f5f.svg";
export { ForwardRef as ReactComponent };